<div class="categories">
    <div *ngFor="let buttonlabel of buttonLabels">
        <button class="button filled-green-button" (click)="redirectLessonPage(buttonlabel.title, buttonlabel.index)">{{buttonlabel.title}}</button>
    </div>

</div>

